module.exports = __webpack_public_path__ + "static/img/index_ai_ppt.bde8288.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/index/index_ai_ppt.png
// module id = w3Gn
// module chunks = 1